export default __webpack_public_path__ + "70ea0bdbadba74701e19940227f22095.png";